import whatsappIcon from "../assets/icons/whatsapp.svg";
import emailIcon from "../assets/icons/email.svg";
import allUsers from "../assets/icons/todos.svg";
import smsIcon from "../assets/icons/sms.svg";
import botIcon from "../assets/icons/bot.svg";
import portalImg from "../assets/icons/monitor.svg";
import phoneIcon from "../assets/icons/phone_white.svg";
import agenteVirtualIcon from "../assets/icons/agente-virtual.svg";
import webChatIcon from "../assets/icons/webchat.svg";

import phoneIconGreen from "../assets/icons/phone.svg";
import smsIconGreen from "../assets/icons/sms_green.svg";
import botIconGreen from "../assets/icons/bot_green.svg";
import portalImgGreen from "../assets/icons/monitor_green.svg";
import whatsappIconGreen from "../assets/icons/whatsapp_green.svg";
import emailIconGreen from "../assets/icons/email_green.svg";
import instagramIconGreen from "../assets/icons/instagram.svg";
import facebookIconGreen from "../assets/icons/facebook.svg";
import twitterIconGreen from "../assets/icons/twitter.svg";
import telegramIconGreen from "../assets/icons/telegram.svg";

export const icons = {
  whatsapp: { icons: whatsappIcon },
  email: { icons: emailIcon },
  todos: { icons: allUsers },
  sms: { icons: smsIcon },
  chatbot: { icons: botIcon },
  portal: { icons: portalImg },
  ligacao: { icons: phoneIcon },
  webchat: { icons: webChatIcon },
  agenteVirtual: { icons: agenteVirtualIcon },
};

export const greenIcons = {
  whatsapp: { icons: whatsappIconGreen },
  email: { icons: emailIconGreen },
  sms: { icons: smsIconGreen },
  chatbot: { icons: botIconGreen },
  portal: { icons: portalImgGreen },
  ligacao: { icons: phoneIconGreen },
  telegram: { icons: telegramIconGreen },
  instagram: { icons: instagramIconGreen },
  facebook: { icons: facebookIconGreen },
  twitter: { icons: twitterIconGreen },
};
